import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Elmsworth Academy",
    description: "Elmsworth Academy is a mixed 11 to 16 secondary school. Find news, term dates, admissions, Ofsted and exam results, policies and information for parents and students.",
    url: getOrigin(),
    ogImage: 'https://elmsworth-academy.cdn.modulify.website/site/og-image.jpg'
}

export const school = {
    name: "Elmsworth Academy",
    phase: "Mixed 11 to 16 academy",
    motto: "Ambition. Kindness. Courage.",
    trust: "Elmsworth Learning Trust",
    studentCount: "1,150",
    address: {
        street: "Beacon Hill Road",
        town: "Elmsworth",
        postcode: "EL4 2QT"
    },
    phone: {
        display: "01632 960 418",
        href: 'tel:+441632960418'
    },
    absenceLine: {
        display: "01632 960 419",
        href: 'tel:+441632960419'
    },
    email: 'office@elmsworthacademy.org.uk',
    safeguardingEmail: 'safeguarding@elmsworthacademy.org.uk',
    sencoEmail: 'senco@elmsworthacademy.org.uk',
    people: {
        headteacher: "Mrs Rebecca Hale",
        chairOfGovernors: "Mrs Anita Sharma",
        senco: "Mr James Okoro",
        designatedSafeguardingLead: "Ms Claire Bennett",
        enquiries: "Mrs Joanne Price"
    },
    schoolDay: {
        start: "8:40am",
        end: "3:10pm",
        weeklyHours: "32.5 hours"
    },
    officeHours: "Monday to Thursday, 8am to 4:30pm. Friday, 8am to 4pm."
}
